import React, { Component } from 'react'

const toolbar = [
  'bold',
  'italic',
  'strikethrough',
  'heading',
  'heading-smaller',
  'heading-bigger',
  'heading-1',
  'heading-2',
  'heading-3',
  'code',
  'quote',
  'unordered-list',
  'ordered-list',
  'clean-block',
  'link',
  'image',
  'horizontal-rule',
  'preview',
  'side-by-side',
  'guide',
  'undo',
  'redo',
]

class Editor extends Component {
  componentDidMount() {
    console.log('Editor componentDidMount')

    this.easyMDE = new window.EasyMDE({
      element: this.textarea,
      toolbar,
      maxHeight: 'calc(100vh - 191px)',
    })

    this.easyMDE.value(this.props.content || '')
  }

  componentDidUpdate(prevProps) {
    console.log('Editor componentDidUpdate')
    if (!prevProps.cancelAttempt && this.props.cancelAttempt) {
      if (this.easyMDE.value() !== this.props.content) {
        window.confirm('Are you sure you want to discard these changes?') &&
          this.props.setSavedOrCancelled('cancelled')
      } else {
        this.props.setSavedOrCancelled('cancelled')
      }
    }
  }

  componentWillUnmount() {
    console.log('Editor componentWillUnmount')
    this.props.handleChange(this.easyMDE.value())
  }

  render() {
    return (
      <div style={{ display: this.props.editing ? 'block' : 'none' }}>
        <textarea
          ref={element => {
            this.textarea = element
          }}
        />
      </div>
    )
  }
}

export default Editor
